{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "description": "Transaction data type identifier."
    },
    "credential_ids": {
      "type": "array",
      "items": {
        "type": "string"
      },
      "description": "Credential query ids this transaction data applies to."
    },
    "payload": {
      "description": "Transaction details. Required for TS12 SCA transaction data."
    }
  },
  "required": [
    "type",
    "credential_ids"
  ],
  "additionalProperties": {},
  "$id": "./TransactionData.schema.json",
  "title": "TransactionData"
}
